/* !
 * product.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
  const a = "is-active";
  const v = "is-visible";
  const path = window.location.pathname;

  const productAccordion = () => {
    const buttons = document.querySelectorAll(".product-search-item-ttl");

    function handleButtonClick(e) {
      const body = e.currentTarget.nextElementSibling;
      const text = body.children[0];
      const textHeight = text.offsetHeight;

      const menu = e.currentTarget.parentNode;
      menu.classList.toggle("open");

      if (menu.classList.contains("open")) {
        body.style.height = textHeight + "px";
      } else {
        body.style.height = 0;
      }
    }

    function addEventListeners() {
      if (window.innerWidth <= 1024) {
        buttons.forEach((button) => {
          button.addEventListener("click", handleButtonClick);
        });
      } else {
        buttons.forEach((button) => {
          button.removeEventListener("click", handleButtonClick);
        });
      }
    }

    // 初期化時にイベントリスナーを追加
    addEventListeners();

    // ウィンドウのサイズが変更されたときに、イベントリスナーを再評価
    window.addEventListener("resize", addEventListeners);
  };

  // if(document.querySelectorAll('.mod-slider01Wrap').length) {
  //     document.querySelectorAll('.mod-slider01Wrap').forEach((ele,idx) => {
  //         let sliderid = 'mod-slider01_'+idx;
  //         ele.setAttribute('id',sliderid);
  //         sliderid = '#'+sliderid;
  //         let swiper = new Swiper(sliderid + " .mod-slider01", {
  //             slidesPerView: "auto",
  //             spaceBetween: 22,
  //             speed: 1000,
  //             autoplay: true,
  //             watchSlidesProgress: true,
  //             pagination: {
  //                 el: sliderid + ' .mod-slider01-control .swiper-pagination',
  //                 clickable: true,
  //             },
  //             breakpoints: {
  //                 768: {
  //                     slidesPerView: "auto",
  //                     spaceBetween: 22,
  //                 }
  //             },
  //         });
  //         document.querySelector(sliderid + ' .mod-slider01-control-button').addEventListener('click', (e) => {
  //             console.log("hoge",e.currentTarget,swiper)
  //             if (!(e.currentTarget.classList.contains(a))) {
  //                 e.currentTarget.ariaLabel = '停止';
  //                 e.currentTarget.classList.add(a);
  //                 swiper.autoplay.start();
  //             } else {
  //                 e.currentTarget.ariaLabel = '再生';
  //                 e.currentTarget.classList.remove(a);
  //                 swiper.autoplay.stop();
  //             }
  //         });
  //     });
  // };

  const currentUrl = () => {
    let currentUrl = window.location.href;
    let links = document.querySelectorAll(".product-button");

    links.forEach(function (link) {
      if (link.href == currentUrl) {
        link.classList.add(a);
      }
    });
  };

  const selectedOption = () => {
    let currentUrl = window.location.pathname;
    let selectElement = document.querySelector(".js-product-select");
    if (!selectElement) return;
    for (let i = 0; i < selectElement.options.length; i++) {
      let option = selectElement.options[i];

      if (option.value === currentUrl) {
        option.selected = true;
        break;
      }
    }
  };

  const applicationsAccordion = () => {
    let productAccordions = document.querySelectorAll(".js-product-accordion");
    let applicationBoxes = document.querySelectorAll(
      ".product-applications-accordion-box"
    );
    let titles = document.querySelectorAll(".js-product-accordion ._ttl");

    productAccordions.forEach(function (accordion) {
      accordion.addEventListener("click", function () {
        let applicationBox = this.querySelector(
          ".product-applications-accordion-box"
        );
        let title = this.querySelector(".js-product-accordion ._ttl");

        if (applicationBox) {
          applicationBox.classList.toggle(a);

          if (title) {
            title.classList.toggle(a);
          }

          applicationBoxes.forEach(function (box) {
            if (box !== applicationBox) {
              box.classList.remove(a);
            }
          });
          titles.forEach(function (ttl) {
            if (ttl !== title) {
              ttl.classList.remove(a);
            }
          });
        }
      });
    });
  };

  const productSideNav = () => {
    let sideNav = document.querySelector(".product-sideNav");
    let sideNavBtn = document.querySelector(".product-sideNav-btn");
    let sideNavLink = document.querySelector(".product-sideNav-link");
    let sideNavBtnTxt = document.querySelector(".product-sideNav-btn-txt");

    // 「rt_cf_cit_url」クラスが「product-sideNav-link」内に存在するかチェック
    if (sideNavLink) {
      let rtCfCitUrlExists =
        sideNavLink.querySelector(".rt_cf_cit_url") !== null;

      // 存在する場合、「product-sideNav」要素を表示
      if (rtCfCitUrlExists) {
        sideNav.style.display = "block";
      } else {
        sideNav.style.display = "none";
      }
    }

    handleResize(); // 初期読み込み時にも処理を実行
    function handleResize() {
      let windowWidth = window.innerWidth;
      let jsSideNavContainer = document.querySelector(
        ".product-sideNav-link ul"
      );
      let jsSideNavContainerList = document.querySelector(
        ".product-sideNav-link ul li"
      );
      let jsSideNavElements = document.querySelectorAll(".js-sideNav");

      jsSideNavElements.forEach((nav) => {
        let rtCfCitUrl = nav.querySelector(".rt_cf_cit_url");

        // .rt_cf_cit_url クラスを持つ要素が存在しない場合、該当する .js-sideNav 要素を削除
        if (!rtCfCitUrl) {
          nav.parentNode.removeChild(nav);
        }
      });

      // 更新された .js-sideNav 要素リストを取得
      jsSideNavElements = document.querySelectorAll(".js-sideNav");

      // 1024px 以下の場合
      let numElements = jsSideNavElements.length;

      if (numElements >= 4 && numElements < 6) {
        // 4件または5件の場合、6件にするための空の枠を追加
        for (let i = numElements; i < 6; i++) {
          let emptyNav = document.createElement("li");
          emptyNav.classList.add(
            "js-sideNav",
            "cf_ci_contact_info",
            "empty-nav"
          );
          jsSideNavContainer.appendChild(emptyNav);
        }
      }

      // numElementsが2件の場合、最初のempty-navに「is-radius」クラスを追加
      if (numElements === 2) {
        jsSideNavContainerList.classList.add("is-radius");
      }
    }

    if (sideNavBtn) {
      sideNavBtn.addEventListener("click", function () {
        if (sideNavLink.classList.contains(a)) {
          sideNavLink.classList.remove(a);
          let path = window.location.pathname;
          sideNavBtn.classList.remove(a);

          var newHTML =
            '<svg aria-hidden="true" class="_left">' +
            '<use xlink:href="/common/svg/sprite.svg#dot"></use>' +
            "</svg>";

          document.querySelector(".product-sideNav-btn-dot").innerHTML =
            newHTML;
        } else {
          sideNavLink.classList.add(a);
          sideNavBtn.classList.add(a);

          var newHTML =
            '<svg aria-hidden="true" class="_left">' +
            '<use xlink:href="/common/svg/sprite.svg#close"></use>' +
            "</svg>";

          document.querySelector(".product-sideNav-btn-dot").innerHTML =
            newHTML;
        }
      });
    }
  };

  const searchMeshList = () => {
    // json出力部分 ------------------------
    if (document.querySelectorAll(".js-searchMeshList-json").length) {
      // json定義---------------------
      const getJSONfiles = () => {
        return `/ajax/products/meshsearch.json`;
      };

      // nullチェック---------------------
      const nullcheck = (val) => {
        if (val === null) {
          // val = '';
          return "";
        }
        return val;
      };

      // html出力---------------------
      const addHTML = (_list, page = 1, itemsPerPage = 20) => {
        let HTML = "";
        const startIndex = (page - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const paginatedList = _list.slice(startIndex, endIndex);

        let path = window.location.pathname;

        paginatedList.forEach(function (val) {
          let material;
          if (path.includes("/eng/")) {
            material = val.cf_ms_material_en;
          } else if (path.includes("/cn/")) {
            material = val.cf_ms_material_cn;
          } else {
            material = val.cf_ms_material_jp;
          }

          HTML += `<tr id="${val._key}">
			            <td>${val.cf_ms_product_name}</td>
			            <td>${val.cf_ms_meshcount}</td>
			            <td>${val.cf_ms_opening}</td>
			            <td>${val.cf_ms_aperture}</td>
			            <td>${val.cf_ms_thickness}</td>
			            <td>${material}</td>
			            <td>${val.cf_ms_resistance}</td>
			        </tr>`;
        });

        const table = document.querySelector(".js-searchMeshList-json table");
        const tbody = table.querySelector("tbody");
        tbody.querySelectorAll("tr").forEach((tr) => tr.remove());
        tbody.insertAdjacentHTML("beforeend", HTML);
      };

      // ページャーを更新する関数
      const updatePaginator = (_list, itemsPerPage = 20) => {
        const totalPages = Math.ceil(_list.length / itemsPerPage);
        const paginator = document.querySelector(".mod-paginate");

        const updatePaginationHTML = (currentPage) => {
          const maxVisiblePages = 5; // 一度に表示するページ数
          let paginationHTML = "";
          const startPage = Math.max(1, currentPage - 2); // 現在のページの2ページ前から
          const endPage = Math.min(totalPages, currentPage + 2); // 現在のページの2ページ後まで

          if (currentPage > 1) {
            paginationHTML += `
			                <a class="mod-paginate-prev02" aria-label="先頭のページへ"><svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_left2" /></svg></a>
			                <a class="mod-paginate-prev" aria-label="前のページへ"><svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>
			            `;
          }

          // ページ番号を表示
          for (let i = startPage; i <= endPage; i++) {
            if (i === currentPage) {
              paginationHTML += `<span class="mod-paginate-index active">${i}</span>`;
            } else {
              paginationHTML += `<a class="mod-paginate-index" data-page="${i}">${i}</a>`;
            }
          }

          if (currentPage < totalPages) {
            paginationHTML += `
			                <a class="mod-paginate-next" aria-label="次のページへ"><svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>
			                <a class="mod-paginate-next02" aria-label="最後のページへ"><svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_right2" /></svg></a>
			            `;
          }

          paginator.innerHTML = paginationHTML;

          // ページ番号クリック時のイベントリスナー
          paginator.querySelectorAll(".mod-paginate-index").forEach((link) => {
            link.addEventListener("click", (e) => {
              const page = parseInt(e.target.getAttribute("data-page"));
              addHTML(_list, page);
              updatePaginationHTML(page);
            });
          });

          // 先頭ページに移動
          if (paginator.querySelector(".mod-paginate-prev02")) {
            paginator
              .querySelector(".mod-paginate-prev02")
              .addEventListener("click", () => {
                addHTML(_list, 1);
                updatePaginationHTML(1);
              });
          }

          // 前のページに移動
          if (paginator.querySelector(".mod-paginate-prev")) {
            paginator
              .querySelector(".mod-paginate-prev")
              .addEventListener("click", () => {
                const newPage = Math.max(currentPage - 1, 1);
                addHTML(_list, newPage);
                updatePaginationHTML(newPage);
              });
          }

          // 次のページに移動
          if (paginator.querySelector(".mod-paginate-next")) {
            paginator
              .querySelector(".mod-paginate-next")
              .addEventListener("click", () => {
                const newPage = Math.min(currentPage + 1, totalPages);
                addHTML(_list, newPage);
                updatePaginationHTML(newPage);
              });
          }

          // 最後のページに移動
          if (paginator.querySelector(".mod-paginate-next02")) {
            paginator
              .querySelector(".mod-paginate-next02")
              .addEventListener("click", () => {
                addHTML(_list, totalPages);
                updatePaginationHTML(totalPages);
              });
          }
        };

        updatePaginationHTML(1);
      };

      // json出力・イベント---------------------
      fetch(getJSONfiles())
        .then((data) => data.json())
        .then((data) => {
          if (data.rt_bn_meshsearch.length) {
            let _array = [];
            data.rt_bn_meshsearch.forEach((item) => {
              let statuscheck = true;
              if (location.pathname.split("/")[1] == "eng") {
                if (item.cf_ms_status_en == "0") {
                  statuscheck = false;
                }
              } else if (location.pathname.split("/")[1] == "cn") {
                if (item.cf_ms_status_cn == "0") {
                  statuscheck = false;
                }
              } else {
                if (item.cf_ms_status_jp == "0") {
                  statuscheck = false;
                }
              }
              if (statuscheck) {
                _array.push({
                  _key: item._key,
                  cf_ms_aperture: nullcheck(item.cf_ms_aperture),
                  cf_ms_material1_jp: nullcheck(item.cf_ms_material1_jp),
                  cf_ms_material_jp: nullcheck(item.cf_ms_material_jp),
                  cf_ms_material1_en: nullcheck(item.cf_ms_material1_en),
                  cf_ms_material_en: nullcheck(item.cf_ms_material_en),
                  cf_ms_material1_cn: nullcheck(item.cf_ms_material1_cn),
                  cf_ms_material_cn: nullcheck(item.cf_ms_material_cn),
                  cf_ms_meshcount: nullcheck(item.cf_ms_meshcount),
                  cf_ms_opening: nullcheck(item.cf_ms_opening),
                  cf_ms_opening_min: nullcheck(item.cf_ms_opening_min),
                  cf_ms_product_name: nullcheck(item.cf_ms_product_name),
                  cf_ms_resistance: nullcheck(item.cf_ms_resistance),
                  cf_ms_status_jp: nullcheck(item.cf_ms_status_jp),
                  cf_ms_thickness: nullcheck(item.cf_ms_thickness),
                });
              }
            });

            // console.log(_array);

            // 検索結果数の更新
            const updateResultCount = (filteredArray) => {
              const resultCountElem = document.querySelector(
                ".product-search-result-num span"
              );
              resultCountElem.textContent = filteredArray.length;
            };

            // ページロード時パラメータチェック・html要素をchecked、selected状態に ------------------------
            const urlParams = new URLSearchParams(window.location.search);
            // チェックボックスの状態を設定
            document
              .querySelectorAll('input[type="checkbox"]')
              .forEach((checkbox) => {
                if (urlParams.has(checkbox.name)) {
                  const values = urlParams.getAll(checkbox.name);
                  if (values.includes(checkbox.value)) {
                    checkbox.checked = true;
                  }
                }
              });
            // セレクトボックスの状態を設定
            document.querySelectorAll("select").forEach((select) => {
              if (urlParams.has(select.name)) {
                select.value = urlParams.get(select.name);
              }
            });
            // ------------------------------------------------------------------------

            const applyFilters = () => {
              let filteredArray = structuredClone(_array);
              const queryParams = [];
            
              // チェックされているチェックボックスを取得
              document
                .querySelectorAll('.product-search-content input[type="checkbox"]:checked')
                .forEach((elem) => {
                  if (!(elem.value === "")) {
                    queryParams.push({
                      name: elem.name,
                      value: elem.value,
                      text: elem.nextElementSibling.textContent,
                    });
                  }
                });
            
              // OR条件でチェックボックスのフィルタリングを実行
              // チェックボックスが1つ以上選択されている場合のみフィルタリング
              if (queryParams.length > 0) {
                filteredArray = filteredArray.filter(function (elem) {
                  // queryParams のいずれかの条件に一致するかどうかを確認 (OR)
                  return queryParams.some(function (param) {
                    // elem に param.name プロパティが存在し、値が一致するか確認
                    return elem.hasOwnProperty(param.name) && elem[param.name] == param.text;
                  });
                });
              }
            
              // OR条件でフィルタリングの実行
              let tempArray = [];
            
              // 目開き
              let openingLower = document.getElementById("cf_ms_opening_lower").value;
              let openingUpper = document.getElementById("cf_ms_opening_upper").value;
              if (openingLower || openingUpper) {
                if (parseFloat(openingLower) > parseFloat(openingUpper)) {
                  tempArray = [];
                } else {
                  tempArray = tempArray.concat(
                    filteredArray.filter(function (elem) {
                      if (!elem.cf_ms_opening) return false;
                      let openingValue = parseFloat(elem.cf_ms_opening.replace(/,/g, ""));
                      let lowerLimit = openingLower ? parseFloat(openingLower) : -Infinity;
                      let upperLimit = openingUpper ? parseFloat(openingUpper) : Infinity;
                      return openingValue >= lowerLimit && openingValue <= upperLimit;
                    })
                  );
                }
              }
            
              // 開口率
              let aperture = document.getElementById("cf_ms_aperture").value;
              if (aperture) {
                let lowerLimit = -Infinity,
                  upperLimit = Infinity;
                if (aperture.includes("～")) {
                  let [lower, upper] = aperture.split("～").map(Number);
                  if (lower > upper) {
                    tempArray = [];
                  } else {
                    lowerLimit = parseFloat(lower);
                    upperLimit = parseFloat(upper);
                  }
                } else if (aperture.includes("以上")) {
                  lowerLimit = parseFloat(aperture);
                }
                tempArray = tempArray.concat(
                  filteredArray.filter(function (elem) {
                    if (!elem.cf_ms_aperture) return false;
                    let apertureValue = parseFloat(elem.cf_ms_aperture);
                    return apertureValue >= lowerLimit && apertureValue <= upperLimit;
                  })
                );
              }
            
              // 厚み
              let thicknessLower = document.getElementById("cf_ms_thickness_lower").value;
              let thicknessUpper = document.getElementById("cf_ms_thickness_upper").value;
              if (thicknessLower || thicknessUpper) {
                if (parseFloat(thicknessLower) > parseFloat(thicknessUpper)) {
                  tempArray = [];
                } else {
                  tempArray = tempArray.concat(
                    filteredArray.filter(function (elem) {
                      if (!elem.cf_ms_thickness) return false;
                      let thicknessValue = parseFloat(String(elem.cf_ms_thickness).replace(/,/g, ""));
                      let lowerLimit = thicknessLower ? parseFloat(thicknessLower) : -Infinity;
                      let upperLimit = thicknessUpper ? parseFloat(thicknessUpper) : Infinity;
                      return thicknessValue >= lowerLimit && thicknessValue <= upperLimit;
                    })
                  );
                }
              }
            
              // 比通気抵抗フィルタリング
              let resistance = document.getElementById("cf_ms_resistance").value;
              if (resistance) {
                let lowerLimit = -Infinity,
                  upperLimit = Infinity;
                if (resistance.includes("～")) {
                  let [lower, upper] = resistance.split("～").map(Number);
                  if (lower > upper) {
                    tempArray = [];
                  } else {
                    lowerLimit = parseFloat(lower);
                    upperLimit = parseFloat(upper);
                  }
                } else if (resistance.includes("以上")) {
                  lowerLimit = parseFloat(resistance);
                }
                tempArray = tempArray.concat(
                  filteredArray.filter(function (elem) {
                    if (!elem.cf_ms_resistance) return false;
                    let resistanceValue = parseFloat(elem.cf_ms_resistance);
                    return resistanceValue >= lowerLimit && resistanceValue <= upperLimit;
                  })
                );
              }
            
              // メッシュ数
              let meshCountLower = document.getElementById("cf_ms_meshcount_lower")?.value;
              let meshCountUpper = document.getElementById("cf_ms_meshcount_upper")?.value;
              if (meshCountLower || meshCountUpper) {
                if (parseFloat(meshCountLower) > parseFloat(meshCountUpper)) {
                  tempArray = [];
                } else {
                  tempArray = tempArray.concat(
                    filteredArray.filter(function (elem) {
                      if (!elem.cf_ms_meshcount) return false;
                      // 左側の数値を基準にする
                      let meshCountValue = parseFloat(elem.cf_ms_meshcount.split(/[^\d.]+/)[0].replace(/,/g, ""));
                      let lowerLimit = meshCountLower ? parseFloat(meshCountLower) : -Infinity;
                      let upperLimit = meshCountUpper ? parseFloat(meshCountUpper) : Infinity;
                      return meshCountValue >= lowerLimit && meshCountValue <= upperLimit;
                    })
                  );
                }
              }
            
              // フィルターが適用されていない場合、全件表示
              if (
                queryParams.length === 0 &&
                !openingLower &&
                !openingUpper &&
                !aperture &&
                !thicknessLower &&
                !thicknessUpper &&
                !resistance &&
                !meshCountLower &&
                !meshCountUpper
              ) {
                filteredArray = _array;
              } else {
                filteredArray = tempArray.length > 0 ? tempArray : filteredArray;
              }
            
              // メッシュ数フィルターの修正
              if (meshCountLower && parseFloat(meshCountLower) >= 1000) {
                filteredArray = filteredArray.filter(function (elem) {
                  let meshCountValue = parseFloat(
                    elem.cf_ms_meshcount.split(/[^\d.]+/)[0].replace(/,/g, "")
                  );
                  return meshCountValue >= 1000;
                });
              }
            
              // console.log(filteredArray,"filteredArray");
              addHTML(filteredArray);
              updatePaginator(filteredArray);
              updateResultCount(filteredArray);
            };                        

            // 初期ロード時にフィルターを適用
            applyFilters();

            // 検索ボタンを押下 ------------------------
            document
              .getElementById("submit")
              .addEventListener("click", applyFilters);

            // クリアボタン押下でパラメータ削除 ------------------------
            document.getElementById("clear").addEventListener("click", () => {
              // チェックボックスの選択状態をクリア
              document
                .querySelectorAll('input[type="checkbox"]')
                .forEach((checkbox) => {
                  checkbox.checked = false;
                });
              // セレクトボックスの選択状態をクリア
              document.querySelectorAll("select").forEach((select) => {
                select.value = "";
              });
              // URLのクエリパラメータを削除
              history.pushState({}, document.title, window.location.pathname);
              applyFilters();
            });
          }
        });
    }
  };

  const productCreateLinks = () => {
    // JSONファイルのパスを配列で定義
    const jsonFiles = [
      "/ajax/product/search-category.json",
      "/ajax/product/search-category-materials-technologies.json",
      "/ajax/product/search-service.json",
    ];

    // 全てのJSONファイルを取得して、データを結合する
    Promise.all(
      jsonFiles.map((file) => fetch(file).then((response) => response.json()))
    ).then((jsonData) => {
      // 全てのデータを一つに結合
      const mergedData = jsonData.reduce(
        (acc, data) => {
          acc.rt_bn_contact_info_list = acc.rt_bn_contact_info_list.concat(
            data.rt_bn_contact_info_list
          );
          return acc;
        },
        { rt_bn_contact_info_list: [] }
      );

      // 現在のURLパスを取得
      const currentPath = window.location.pathname;
      const currentPathSegments = currentPath
        .split("/")
        .filter((segment) => segment); // URLパスのセグメントを配列に分割

      // 全てのrt_bn_product_category_list内のproduct-link01クラス要素に対して処理を行う
      document.querySelectorAll(".product-link01").forEach((link) => {
        const href = link.getAttribute("href"); // hrefを取得

        // JSONデータの_keyとリンクのhrefが一致するか確認
        const matchingItem = mergedData.rt_bn_contact_info_list.find((item) => {
          const itemKey = item._key;

          // 「cn」または「eng」で始まる場合は、hrefにそれが含まれているかを確認
          if (itemKey.startsWith("cn/") || itemKey.startsWith("eng/")) {
            return href === `/${itemKey}/`; // 完全一致する場合
          }

          // console.log(itemKey,"itemKey");
          // console.log(href,"href");

          // その他の場合は、hrefの先頭に「/」を加えた形で一致するかを確認
          return href === `/${itemKey}/`;
        });

        // 一致する要素がある場合のみ処理を実行
        if (matchingItem) {
          // console.log(matchingItem, "test");
          // js-iconCreateクラス要素を取得
          const ul = link.closest(".mod-box1").querySelector(".js-iconCreate");

          // 一致する要素がある場合ulをクリア
          ul.innerHTML = "";

          // cf_ci_contact_info内のデータをループ
          matchingItem.cf_ci_contact_info.forEach((contact) => {
            // contact.cf_cit_urlが空の場合は処理をスキップ
            if (!contact.cf_cit_url) {
              return;
            }

            // "eng"であれば対応するタイトルに変更
            if (currentPath.includes("/eng/")) {
              switch (contact.cf_cit_title) {
                case "お問い合わせ":
                  contact.cf_cit_title = "Contact us";
                  break;
                case "資料ダウンロード":
                  contact.cf_cit_title = "Download Materials";
                  break;
                case "よくあるご質問":
                  contact.cf_cit_title = "Frequently Asked Questions";
                  break;
                case "試験依頼":
                  contact.cf_cit_title = "Request for Testing";
                  break;
                case "Nafitec®試験用ふるいレンタル":
                  contact.cf_cit_title = "Nafitec® Test Sieve Rental";
                  break;
                case "立ち合い印刷サービス":
                  contact.cf_cit_title = "Attended printing service";
                  break;
                default:
                  break;
              }
            }

            // "cn"であれば対応するタイトルに変更
            if (currentPath.includes("/cn/")) {
              switch (contact.cf_cit_title) {
                case "お問い合わせ":
                  contact.cf_cit_title = "咨询";
                  break;
                case "資料ダウンロード":
                  contact.cf_cit_title = "下载资料";
                  break;
                case "よくあるご質問":
                  contact.cf_cit_title = "常见问题";
                  break;
                case "試験依頼":
                  contact.cf_cit_title = "试验委托";
                  break;
                case "Nafitec®试验用ふるいレンタル":
                  contact.cf_cit_title = "Nafitec®试验用筛租赁";
                  break;
                case "立ち合い印刷サービス":
                  contact.cf_cit_title = "会同印刷服务";
                  break;
                default:
                  break;
              }
            }

            // 対応するアイコンIDを決定
            let iconId = "#contact"; // デフォルトはお問い合わせ

            // URLによって分岐
            if (currentPath.includes("/eng/")) {
              switch (contact.cf_cit_title) {
                case "Contact us":
                  iconId = "#contact";
                  break;
                case "Download Materials":
                  iconId = "#download";
                  break;
                case "Frequently Asked Questions":
                  iconId = "#qa";
                  break;
                case "Request for Testing":
                  iconId = "#icon02";
                  break;
                case "Test Sieve Rental":
                  iconId = "#icon03";
                  break;
                case "Attended printing service":
                  iconId = "#icon01";
                  break;
                default:
                  iconId = "#contact"; // デフォルトはお問い合わせ
                  break;
              }
            } else if (currentPath.includes("/cn/")) {
              switch (contact.cf_cit_title) {
                case "咨询":
                  iconId = "#contact";
                  break;
                case "下载资料":
                  iconId = "#download";
                  break;
                case "常见问题":
                  iconId = "#qa";
                  break;
                case "试验委托":
                  iconId = "#icon02";
                  break;
                case "Nafitec®试验用筛租赁":
                  iconId = "#icon03";
                  break;
                case "会同印刷服务":
                  iconId = "#icon01";
                  break;
                default:
                  iconId = "#contact"; // デフォルトはお問い合わせ
                  break;
              }
            } else {
              contact.cf_cit_title = contact.cf_cit_title.replace(/<br>/g, "");
              switch (contact.cf_cit_title) {
                case "お問い合わせ":
                  iconId = "#contact";
                  break;
                case "資料ダウンロード":
                  contact.cf_cit_title = "資料<br>ダウンロード";
                  iconId = "#download";
                  break;
                case "よくあるご質問":
                  iconId = "#qa";
                  break;
                case "試験依頼":
                  iconId = "#icon02";
                  break;
                case "Nafitec®試験用ふるいレンタル":
                  iconId = "#icon03";
                  break;
                case "立ち合い印刷サービス":
                  contact.cf_cit_title = "立ち合い印刷<br>サービス";
                  iconId = "#icon01";
                  break;
                default:
                  iconId = "#contact"; // デフォルトはお問い合わせ
                  break;
              }
            }

            // li要素を作成し、ul要素に追加する
            const li = document.createElement("li");
            li.innerHTML = `<a href="${contact.cf_cit_url}">
                                          <svg aria-hidden="true" class="_left"><use xlink:href="/common/svg/sprite.svg${iconId}"></use></svg>
                                          <span data-mh="_txt">${contact.cf_cit_title}</span>
                                        </a>`;
            ul.appendChild(li);
            const $elements = document.querySelectorAll("[data-mh]");
            const groups = new Map();

            $elements.forEach((ele) => {
              ele.style.height = "auto";
            }); // 初期化

            $elements.forEach((ele) => {
              const attributeName = ele.getAttribute("data-mh");
              if (!groups.has(attributeName)) {
                groups.set(attributeName, []);
              }
              groups.get(attributeName).push(ele);
            });
            groups.forEach((group) => {
              const attributeGroups = new Map();
              group.forEach((ele) => {
                const attributeName = ele.getAttribute("data-mh");
                const topPosition = ele.getBoundingClientRect().top;
                const key = attributeName + "_" + topPosition;
                if (!attributeGroups.has(key)) {
                  attributeGroups.set(key, []);
                }
                attributeGroups.get(key).push(ele);
              });
              attributeGroups.forEach((item) => {
                const maxHeight = Math.max(
                  ...item.map((ele) => ele.offsetHeight)
                );
                item.forEach((ele2) => {
                  ele2.style.height = `${maxHeight}px`;
                });
              });
            });
          });
        }
      });
    });
  };

  // DOMContentLoadedイベントリスナーを追加
  window.addEventListener("DOMContentLoaded", productCreateLinks);

  const productSearchApplicationsIssuesTabCreate = () => {
    // JSONファイルの定義
    const getJSONfiles = () => {
      let path = window.location.pathname;
      if (path.includes("/eng/")) {
        return `/ajax/eng/product/usage/list.json`;
      } else if (path.includes("/cn/")) {
        return `/ajax/cn/product/usage/list.json`;
      } else {
        return `/ajax/jp/product/usage/list.json`;
      }
    };

    // JSONデータを取得して処理する部分
    fetch(getJSONfiles())
      .then(function (response) {
        return response.json();
      })
      .then(function (jsonData) {
        // jsonDataを正しく取得したか確認するためにログ出力
        // console.log(jsonData);

        // rt_bn_usage_list配列が1つの要素しか持たない前提で、その要素を取得する
        const usageList = jsonData.rt_bn_usage_list[0];

        // URLパスに応じて適切な配列を取得する
        let usages;
        let path = window.location.pathname;
        if (path.includes("/eng/")) {
          usages = usageList.cf_div_usage_en;
        } else if (path.includes("/cn/")) {
          usages = usageList.cf_div_usage_cn;
        } else {
          usages = usageList.cf_div_usage_jp;
        }

        // rt_cf_bu_code要素を取得する
        const rt_cf_bu_codes = document.querySelectorAll(".rt_cf_bu_code");

        // 各rt_cf_bu_codeに対して処理を行う
        rt_cf_bu_codes.forEach(function (rt_cf_bu_code) {
          // rt_cf_bu_code内の文言を取得
          const rt_cf_bu_code_text = rt_cf_bu_code.textContent.trim();

          // JSONデータと比較して該当するデータを探す
          usages.forEach(function (item) {
            if (
              item.cf_us_business !== null &&
              item.cf_us_business.cf_bu_code === rt_cf_bu_code_text
            ) {
              const accordionBox = rt_cf_bu_code.nextElementSibling;
              let HTML = "";
              HTML = `<div class="_link mod-spacer_20">
	                        <a href="${item.cf_us_tech}" class="mod-link01">
	                            <svg aria-hidden="true">
	                                <use xlink:href="/common/svg/sprite.svg#arrow_right"></use>
	                            </svg><span class="td_under">${item.cf_us_name}</span>
	                        </a>
	                    </div>`;
              accordionBox.insertAdjacentHTML("beforeend", HTML);
            }
          });
        });
      });
  };
  window.addEventListener(
    "DOMContentLoaded",
    productSearchApplicationsIssuesTabCreate
  );

  const columnNewsCreate = () => {
    // json定義
    const getJSONfiles = (news_id) => {
      return `/ajax/technology/read/detail/${news_id}.json`;
    };

    document.querySelectorAll(".js-productColumn").forEach((item) => {
      let ids = Array.from(item.querySelectorAll(".rt_cf_n_key")).map((key) =>
        key.textContent.trim()
      );

      ids.forEach((id) => {
        // JSON出力・イベント
        fetch(getJSONfiles(id))
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            if (data.rt_bn_news_info.length) {
              let newsInfo = data.rt_bn_news_info[0];

              let href = newsInfo.rt_href.href;
              let imgSrc = newsInfo.cf_n_thum_img_jp
                ? newsInfo.cf_n_thum_img_jp
                : "/common/images/noimage_webinars.webp";
              let date = newsInfo.rt_cf_n_date.content;
              let category = newsInfo.cf_n_category.cf_nc_name;
              let tags = newsInfo.cf_n_tags
                .map((tag) => `#${tag.cf_nt_name_d}`)
                .join(" ");

              // 現在の日時とrt_cf_n_dateを比較
              let isNew =
                (new Date() - new Date(newsInfo.cf_n_date)) /
                  (1000 * 60 * 60 * 24) <=
                30;

              // 画像のパスを設定
              let imgPath =
                imgSrc === "/common/images/noimage_webinars.webp"
                  ? imgSrc
                  : `/news/news_file/file/${imgSrc}`;

              // デバイスの幅に応じてHTML生成
              let HTML = "";
              if (window.innerWidth <= 1024) {
                HTML = `<div class="swiper-slide js-productColumn">
						        <span class="di_none cf_pd_news_jp">
						            <span class="rt_cf_n_key">${id}</span>
						        </span>
						        <div class="mod-box1" data-mh="tb1">
						            <a href="${href}">
						                <figure class="mod-box1-img">
						                    <img src="${imgPath}" alt="" loading="lazy">
						                </figure>
						                <div class="mod-box1-txt">
						                    <div class="mod-box1-wrap">
						                        <span class="mod-box1-date">${date}</span>
						                        <span class="technology-label">${category}</span>
						                        ${
                                      isNew
                                        ? '<span class="technology-icon">NEW</span>'
                                        : ""
                                    }
						                    </div>
						                    <p class="_title mod-spacer_10" data-mh="tb2">${
                                  newsInfo.cf_n_title_jp
                                }</p>
						                    <div class="mod-box1-wrap _hashtag">
						                        ${tags}
						                    </div>
						                </div>
						            </a>
						        </div>
						    </div>`;
              } else {
                HTML = `<div class="pure-u-1-3 space-u-20-child">
						        <span class="di_none cf_pd_news_jp">
						            <span class="rt_cf_n_key">${id}</span>
						        </span>
						        <div class="mod-box1" data-mh="tb1" style="height: 429px;">
						            <a href="${href}">
						                <figure class="mod-box1-img">
						                    <img src="${imgPath}" alt="" loading="lazy">
						                </figure>
						                <div class="mod-box1-txt">
						                    <div class="mod-box1-wrap">
						                        <span class="mod-box1-date">${date}</span>
						                        <span class="technology-label">${category}</span>
						                        ${
                                      isNew
                                        ? '<span class="technology-icon">NEW</span>'
                                        : ""
                                    }
						                    </div>
						                    <p class="_title mod-spacer_10" data-mh="tb2" style="height: 90px;">${
                                  newsInfo.cf_n_title_jp
                                }</p>
						                    <div class="mod-box1-wrap _hashtag">
						                        ${tags}
						                    </div>
						                </div>
						            </a>
						        </div>
						    </div>`;
              }

              item.insertAdjacentHTML("beforeend", HTML);
            }
          });
      });
    });
  };

  //詳細ページ　大カテゴリFV導線出力
  const productBtnLcategory = () => {
    // JSON定義
    const getJSONfiles = (productBtn_id) => {
      let path = window.location.pathname;
      if (path.includes("/eng/")) {
        return `/ajax/eng/product/1st/${productBtn_id}.json`;
      } else if (path.includes("/cn/")) {
        return `/ajax/cn/product/1st/${productBtn_id}.json`;
      } else {
        return `/ajax/jp/product/1st/${productBtn_id}.json`;
      }
    };

    let idElement = document.querySelector(".rt_cf_pc1_code");
    if (!idElement) {
      return;
    }

    let id = idElement.textContent.trim();
    let isSP = window.innerWidth <= 768;

    // JSON出力・イベント
    fetch(getJSONfiles(id))
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then(function (data) {
        // console.log(data, 'JSON data');

        document
          .querySelectorAll(
            isSP ? ".js-product-categoryList" : ".product-button-wrap"
          )
          .forEach((item) => {
            if (isSP) {
              // 先頭のボタン 出力処理
              let currentPagePath = window.location.pathname; // 現在のページのURLパス
              let productBtnDivision = data.rt_bn_product_list[0];
              let content = productBtnDivision.rt_href_division.content[0];
              let href = productBtnDivision.rt_href_division.href;
              let selectHTML = `<select name="categoryList" class="js-product-categoryList" id="categoryList">
	                        <option value="${
                            href === currentPagePath ? href : ""
                          }" selected>${content}</option>
	                    </select>`;
              item.insertAdjacentHTML("beforeend", selectHTML);

              // 二つ目以降のボタン 出力処理
              data.rt_bn_product_list.forEach((productBtnDivision) => {
                let content2 = productBtnDivision.rt_cf_pd_name.content[0];
                let href2 = productBtnDivision.rt_2nd_category_is
                  ? productBtnDivision.rt_href_2nd.href
                  : productBtnDivision.rt_href_1st.href;
                let selectedAttr = href2 === currentPagePath ? "selected" : "";
                let optionHTML = `<option value="${href2}" ${selectedAttr}>${content2}</option>`;
                item.insertAdjacentHTML("beforeend", optionHTML);
              });

              // ページ遷移処理
              document
                .getElementById("categoryList")
                .addEventListener("change", function () {
                  window.location.href = this.value;
                });
            } else {
              // 先頭のボタン 出力処理
              let productBtnDivision = data.rt_bn_product_list[0];
              let content = productBtnDivision.rt_href_division.content[0];
              let href = productBtnDivision.rt_href_division.href;
              let HTML = `<a href="${href}" class="product-button">
	                        <span>${content}</span>
	                    </a>`;
              item.insertAdjacentHTML("beforeend", HTML);

              // 二つ目以降のボタン 出力処理
              data.rt_bn_product_list.forEach((productBtnDivision) => {
                let contentArray = productBtnDivision.rt_cf_pd_name.content;
                let href2 = productBtnDivision.rt_2nd_category_is
                  ? productBtnDivision.rt_href_2nd.href
                  : productBtnDivision.rt_href_1st.href;

                // `content2` のHTMLを生成
                let contentHTML = contentArray
                  .map((content) => {
                    if (typeof content === "string") {
                      return content;
                    } else if (content.tag === "sup") {
                      return `<sup>${content.content.join("")}</sup>`;
                    } else if (content.tag === "br") {
                      return "<br>"; // brタグを追加
                    }
                  })
                  .join("");

                let HTML2 = `<a href="${href2}" class="product-button">
						        <span>${contentHTML}</span>
						    </a>`;
                item.insertAdjacentHTML("beforeend", HTML2);
              });
            }
          });
      });
  };

  //詳細ページ　中カテゴリ
  const productBtnMcategory = () => {
    // JSON定義
    // const getJSONfiles = (productBtn_id, level) => {
    //     if (level === 'medium') {
    //         return `/ajax/product/2nd/${productBtn_id}.json`;
    //     } else if (level === 'small') {
    //         return `/ajax/product/detail/3rd/${productBtn_id}.json`;
    //     }
    // };

    // // 中カテゴリの処理
    // let idElement = document.querySelector('.rt_cf_pc2_code');
    // let smallIdElements = document.querySelectorAll('.rt_cf_pc3_code');
    // if (!idElement || smallIdElements.length === 0) {
    //     return;
    // }

    // let id = idElement.textContent.trim();
    // let isSP = window.innerWidth <= 768;

    const getJSONfiles = (productBtn_id) => {
      let path = window.location.pathname;
      if (path.includes("/eng/")) {
        return `/ajax/eng/product/2nd/${productBtn_id}.json`;
      } else if (path.includes("/cn/")) {
        return `/ajax/cn/product/2nd/${productBtn_id}.json`;
      } else {
        return `/ajax/jp/product/2nd/${productBtn_id}.json`;
      }
    };

    const getJSONfiles2 = (productBtn_id2) => {
      let path = window.location.pathname;
      if (path.includes("/eng/")) {
        return `/ajax/eng/product/detail/3rd/${productBtn_id2}.json`;
      } else if (path.includes("/cn/")) {
        return `/ajax/cn/product/detail/3rd/${productBtn_id2}.json`;
      } else {
        return `/ajax/jp/product/detail/3rd/${productBtn_id2}.json`;
      }
    };

    let idElement = document.querySelector(".rt_cf_pc2_code");
    if (!idElement) {
      return;
    }

    let id = idElement.textContent.trim();
    let isSP = window.innerWidth <= 768;

    document
      .querySelectorAll(
        isSP
          ? ".js-product-categoryListMedium"
          : ".js-product-categoryList-pcMedium"
      )
      .forEach((item) => {
        // JSON出力・イベント
        fetch(getJSONfiles(id))
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then(function (data) {
            // console.log(data, "test")
            if (isSP) {
              // 先頭のボタン 出力処理
              let currentPagePath = window.location.pathname;
              // データ構造のチェックを追加
              if (!data || !data.rt_bn_product_list || !data.rt_bn_product_list.length) {
                console.warn("製品データが見つかりません。");
                return;
              }
              let productBtnDivision = data.rt_bn_product_list[0];
              // rt_href_division が存在するかチェック
              if (!productBtnDivision.rt_href_division) {
                console.warn("rt_href_division データが見つかりません。", productBtnDivision);
                return;
              }
              let content = productBtnDivision.rt_href_division.content[0];
              let href = productBtnDivision.rt_href_division.href;
              let selectHTML = `<select name="categoryListMedium" class="js-product-categoryListMedium" id="categoryListMedium">
                        <option value="${
                          href === currentPagePath ? href : ""
                        }" selected>${content}</option>
                    </select>`;
              item.insertAdjacentHTML("beforeend", selectHTML);

              // 二つ目以降のボタン 出力処理
              data.rt_bn_product_list.forEach((productBtnDivision) => {
                let content2 = productBtnDivision.rt_cf_pd_name.content[0];
                let href2 = productBtnDivision.rt_3rd_category_is
                  ? productBtnDivision.rt_href_3rd.href
                  : productBtnDivision.rt_href_2nd.href;
                let selectedAttr = href2 === currentPagePath ? "selected" : "";
                let optionHTML = `<option value="${href2}" ${selectedAttr}>${content2}</option>`;
                item.insertAdjacentHTML("beforeend", optionHTML);
              });

              // ページ遷移処理
              document
                .getElementById("categoryListMedium")
                .addEventListener("change", function () {
                  window.location.href = this.value;
                });
            } else {
              // 先頭のボタン 出力処理
              let productBtnDivision = data.rt_bn_product_list[0];
              let content = productBtnDivision.rt_href_division.content[0];
              let href = productBtnDivision.rt_href_division.href;
              let HTML = `<a href="${href}" class="product-button">
                        <span>${content}</span>
                    </a>`;
              item.insertAdjacentHTML("beforeend", HTML);

              // 二つ目以降のボタン 出力処理
              data.rt_bn_product_list.forEach((productBtnDivision) => {
                let contentArray = productBtnDivision.rt_cf_pd_name.content;
                let href2 = productBtnDivision.rt_3rd_category_is
                  ? productBtnDivision.rt_href_3rd.href
                  : productBtnDivision.rt_href_2nd.href;

                // `content2` のHTMLを生成
                let contentHTML = contentArray
                  .map((content) => {
                    if (typeof content === "string") {
                      return content;
                    } else if (content.tag === "sup") {
                      return `<sup>${content.content.join("")}</sup>`;
                    } else if (content.tag === "br") {
                      return "<br>"; // brタグを追加
                    }
                  })
                  .join("");

                let HTML2 = `<a href="${href2}" class="product-button">
					        <span>${contentHTML}</span>
					    </a>`;
                item.insertAdjacentHTML("beforeend", HTML2);
              });
            }
          });
      });

    // 小カテゴリの処理
    document.querySelectorAll(".js-productSmallLinksWrap").forEach((item) => {
      console.log(item.querySelector(".js-productSmallLinks"), "test3");
      // JSON出力・イベント
      let smallId = item.querySelector(".rt_cf_pc3_code").textContent.trim();
      // console.log(smallId,"test4")
      fetch(getJSONfiles2(smallId))
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then(function (data) {
          // console.log(data, "test")
          // 表出力処理
          let trHTML = "";
          data.rt_bn_product_list.forEach((productDetail) => {
            let content = productDetail.rt_cf_pd_name.content[0];
            let href = productDetail.rt_href.href;
            let overview = "";

            if (productDetail.rt_cf_pd_description) {
              overview = productDetail.rt_cf_pd_description.content
                .map((item) => {
                  if (typeof item === "string") {
                    return item;
                  } else if (item.tag === "br") {
                    return "<br>";
                  }
                  return "";
                })
                .join("");
            }
            trHTML += `<tr>
                        <th>
                            <a href="${href}" class="mod-link01">
                                <svg aria-hidden="true">
                                    <use xlink:href="/common/svg/sprite.svg#arrow_right"></use>
                                </svg><span class="td_under">${content}</span>
                            </a>
                        </th>
                        <td>${overview}</td>
                    </tr>`;
          });
          // console.log(trHTML,"test2");
          item
            .querySelector(".js-productSmallLinks")
            .insertAdjacentHTML("beforeend", trHTML);
        });
    });
  };

  //詳細ページ　小カテゴリ
  const productBtnScategory = () => {
    // json定義
    const getJSONfiles = (productBtn_id) => {
      let path = window.location.pathname;
      if (path.includes("/eng/")) {
        return `/ajax/eng/product/3rd/${productBtn_id}.json`;
      } else if (path.includes("/cn/")) {
        return `/ajax/cn/product/3rd/${productBtn_id}.json`;
      } else {
        return `/ajax/jp/product/3rd/${productBtn_id}.json`;
      }
    };

    let idElement = document.querySelector(".rt_cf_pc3_code");
    if (!idElement) {
      return;
    }

    let id = idElement.textContent.trim();
    let isSP = window.innerWidth <= 768;

    document
      .querySelectorAll(
        isSP
          ? ".js-product-categoryListSmall"
          : ".js-product-categoryList-pcSmall"
      )
      .forEach((item) => {
        // JSON出力・イベント
        fetch(getJSONfiles(id))
          .then(function (response) {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then(function (data) {
            // console.log(data, 'JSON data');

            if (isSP) {
              let productBtnDivisions = data.rt_bn_product_list;
              let selectHTML = `<select name="categoryListSmall" class="js-product-categoryListSmall" id="categoryListSmall">`;

              productBtnDivisions.forEach((productBtnDivision) => {
                let content = productBtnDivision.rt_cf_pd_name.content[0];
                let href = productBtnDivision.rt_href.href;

                let currentPageUrl = window.location.pathname;
                let isSelected = currentPageUrl === href ? "selected" : "";

                selectHTML += `<option ${isSelected} value="${href}">${content}</option>`;
              });

              selectHTML += `</select>`;
              item.insertAdjacentHTML("beforeend", selectHTML);

              // ページ遷移処理
              document
                .getElementById("categoryListSmall")
                .addEventListener("change", function () {
                  window.location.href = this.value;
                });
            } else {
              let productBtnDivisions = data.rt_bn_product_list;
              productBtnDivisions.forEach((productBtnDivision) => {
                let content = productBtnDivision.rt_cf_pd_name.content[0];
                let href = productBtnDivision.rt_href.href;
                let HTML = `<a href="${href}" class="product-button">
	                            <span>${content}</span>
	                        </a>`;
                item.insertAdjacentHTML("beforeend", HTML);
              });
            }
          });
      });
  };

  //詳細ページ　大カテゴリ 製品ラインアップリンク出力
  const productLineupLinks = () => {
    // json定義
    const getJSONfiles = (productBtn_id) => {
      let path = window.location.pathname;
      if (path.includes("/eng/")) {
        return `/ajax/eng/product/category/2nd/${productBtn_id}.json`;
      } else if (path.includes("/cn/")) {
        return `/ajax/cn/product/category/2nd/${productBtn_id}.json`;
      } else {
        return `/ajax/jp/product/category/2nd/${productBtn_id}.json`;
      }
    };

    // 各親要素の "rt_bn_product_list" クラスを取得
    document
      .querySelectorAll(".rt_bn_product_list")
      .forEach((parentElement) => {
        // 親要素内にある "rt_cf_pc2_code" を取得
        let idElement = parentElement.querySelector(".rt_cf_pc2_code");
        if (!idElement) {
          return;
        }

        let id = idElement.textContent.trim();

        // JSON出力・イベント
        fetch(getJSONfiles(id))
          .then(function (response) {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then(function (data) {
            // console.log(data, 'JSON data');
            parentElement
              .querySelectorAll(".product-button-wrap2")
              .forEach((item) => {
                let productLinks = data.rt_bn_product_list;
                productLinks.forEach((productLink) => {
                  let contentArray = productLink.rt_cf_pd_name.content;
                  let href = productLink.rt_href_2nd.href;

                  let contentHTML = contentArray
                    .map((content) => {
                      if (typeof content === "string") {
                        return content;
                      } else if (content.tag === "sup") {
                        return `<sup>${content.content.join("")}</sup>`;
                      } else if (content.tag === "br") {
                        return "<br>"; // brタグを追加
                      }
                    })
                    .join("");

                  let selectHTML = `<a href="${href}" class="mod-button"><span>${contentHTML}</span><svg aria-hidden="true" class="_left">
	                            <use xlink:href="/common/svg/sprite.svg#arrow_right"></use>
	                        </svg></a>`;
                  item.insertAdjacentHTML("beforeend", selectHTML);
                });
              });
          });
      });
  };

  //詳細ページ　大カテゴリ 中カテゴリリンク出力
  const productSmallCategoryLinks = () => {
    // json定義
    const getJSONfiles = (productBtn_id) => {
      let path = window.location.pathname;
      if (path.includes("/eng/")) {
        return `/ajax/eng/product/category/3rd/${productBtn_id}.json`;
      } else if (path.includes("/cn/")) {
        return `/ajax/cn/product/category/3rd/${productBtn_id}.json`;
      } else {
        return `/ajax/jp/product/category/3rd/${productBtn_id}.json`;
      }
    };

    const getJSONfiles2 = (productBtn_id2) => {
      let path = window.location.pathname;
      if (path.includes("/eng/")) {
        return `/ajax/eng/product/detail/3rd/${productBtn_id2}.json`;
      } else if (path.includes("/cn/")) {
        return `/ajax/cn/product/detail/3rd/${productBtn_id2}.json`;
      } else {
        return `/ajax/jp/product/detail/3rd/${productBtn_id2}.json`;
      }
    };

    let idElement = document.querySelector(".rt_cf_pc2_code");
    if (!idElement) {
      return;
    }

    let id = idElement.textContent.trim();

    // JSON出力・イベント
    fetch(getJSONfiles(id))
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then(function (data) {
        // console.log(data, 'JSON data');
        let productLinks = data.rt_bn_product_list;
        productLinks.forEach((productLinks) => {
          let content = productLinks.rt_cf_pd_name.content;
          let href = productLinks.rt_href.href;
          let id2 = productLinks.rt_cf_pc3_code.content[0];
          let selectHTML = `<h4 id="${id2}" class="mod-head04 mod-spacer_50 __border __link">
				    <a href="${href}"><span class="td_under">${content}</span><svg aria-hidden="true" class="_icon">
						<use xlink:href="/common/svg/sprite.svg#arrow_right"></use>
					</svg></a>
				</h4>`;
          if (document.querySelector(".js-SmallCategoryLinks")) {
            document
              .querySelector(".js-SmallCategoryLinks")
              .insertAdjacentHTML("beforeend", selectHTML);
          }
          // console.log(content,productLinks.rt_cf_pc3_code.content,"test");
          fetch(getJSONfiles2(id2))
            .then(function (response) {
              if (!response.ok) {
                throw new Error("Network response was not ok");
              }
              return response.json();
            })
            .then(function (data2) {
              // console.log(data2, 'JSON data2');
              // console.log(id2, 'id2');
              let productLinks2 = data2.rt_bn_product_list;

              // h4下のテーブルタグ生成
              let tableHTML =
                '<table class="mod-tbl01"><colgroup><col class="width-u-25"></colgroup>'; // テーブルタグのクラスを指定

              productLinks2.forEach((productLink) => {
                let href = productLink.rt_href.href;
                let ttl = productLink.rt_cf_pd_name.content[0];
                let txt = "";

                if (productLink.rt_cf_pd_description) {
                  txt = productLink.rt_cf_pd_description.content
                    .map((item) => {
                      if (typeof item === "string") {
                        return item;
                      } else if (item.tag === "br") {
                        return "<br>";
                      }
                      return "";
                    })
                    .join("");
                }

                tableHTML += `
					    <tr>
					        <th>
					            <a href="${href}" class="mod-link01">
					                <svg aria-hidden="true">
					                    <use xlink:href="/common/svg/sprite.svg#arrow_right"></use>
					                </svg><span class="td_under">${ttl}</span>
					            </a>
					        </th>
					        <td>${txt}</td>
					    </tr>
					    `;
              });
              tableHTML += "</table>"; // テーブルタグの終了

              // テーブルを挿入するための準備
              let tempDiv = document.createElement("div");
              tempDiv.innerHTML =
                '<div class="mod-spacer_20">' + tableHTML + "</div>"; // テーブルをdivで囲む

              // テーブルを挿入する位置を取得して挿入
              let headBlock = document.getElementById(id2); // idがid2の要素を取得（指定されたHTML内のid）
              if (headBlock) {
                headBlock.insertAdjacentHTML("afterend", tempDiv.innerHTML); // 指定された要素の直後にテーブルを挿入
              }
            });
        });
      });
  };

  //詳細ページ　空項目削除
  const removeProductDetails = () => {
    const columnImages = document.querySelectorAll(".__column_img");
    columnImages.forEach(function (columnImg) {
      const img = columnImg.querySelector("img");
      if (!img) {
        columnImg.remove();
      }
    });

    document.querySelectorAll(".product-column .mod-tbl01 th").forEach((th) => {
      // thの次の兄弟要素がtdかどうかを確認
      const nextElement = th.nextElementSibling;
      if (!nextElement || nextElement.tagName !== "TD") {
        th.remove();
      }
    });

    //製品仕様　最大5件まで
    const rows = document.querySelectorAll(
      ".js-productSpecification .mod-tbl01 tr"
    );
    const maxCount = 5;
    let count = 0;

    rows.forEach((row) => {
      // trが空かどうかを確認
      if (row.textContent.trim() === "") {
        row.remove();
      } else if (count >= maxCount) {
        row.remove();
      } else {
        count++;
      }
    });

    let otherList = document.querySelectorAll(".js-otherList");
    otherList.forEach(function (element) {
      // 子要素の中に rt_cf_pd_feat_img_jp クラスの要素が含まれているかチェック
      const otherList = element.querySelector(".cf_pd_other_list_jp");

      // 両方のクラスが含まれていない場合、その親要素を削除
      if (!otherList) {
        element.remove();
      }
    });

    // 工程　連番にする記述
    let spans = document.querySelectorAll(".product-head ._num");
    for (let i = 0; i < spans.length; i++) {
      spans[i].textContent = String(i + 1).padStart(2, "0");
    }

    //  js-productColumnSliderクラス内のjs-productColumnクラスの要素を取得
    let productColumnSlider = document.querySelector(".js-productColumnSlider");
    let productColumns = document.querySelectorAll(
      ".js-productColumnSlider .js-productColumn"
    );
    //  js-productColumnSliderクラス内にjs-productColumnクラスの要素がある場合
    if (productColumns.length > 0) {
      //  js-productColumnSliderクラス内のmod-slider01-controlクラスの要素を取得
      let sliderControls = document.querySelectorAll(
        ".js-productColumnSlider .mod-slider01-control"
      );
      productColumnSlider.remove();
      // 各mod-slider01-controlクラスの要素を削除
      sliderControls.forEach((control) => {
        control.parentNode.removeChild(control);
      });
    }

    // 製品・技術紹介 削除
    let productInfoWrap = document.querySelector(".js-productInfo");
    if (productInfoWrap) {
      // 各クラスの要素を探す
      let productInfoWrapText = productInfoWrap.querySelector(
        ".rt_cf_pd_lineup_txt"
      );
      let productInfoWrapName =
        productInfoWrap.querySelector(".rt_cf_pc2_name");
      let productInfoWrapName02 =
        productInfoWrap.querySelector(".rt_cf_pc3_name");

      // すべてのクラスが存在しない場合、.js-productInfoWrap 要素を削除
      if (
        !productInfoWrapText &&
        !productInfoWrapName &&
        !productInfoWrapName02
      ) {
        productInfoWrap.remove();
      }
    }

    // 用途例 削除
    let purposeList = document.querySelector(".js-purposeList");
    if (purposeList) {
      // 各クラスの要素を探す
      let purposeListJp = purposeList.querySelector(".cf_pd_purpose_list_jp");
      let purposeListEn = purposeList.querySelector(".cf_pd_purpose_list_en");
      let purposeListCn = purposeList.querySelector(".cf_pd_purpose_list_cn");

      // すべてのクラスが存在しない場合、.js-purposeList 要素を削除
      if (!purposeListJp && !purposeListEn && !purposeListCn) {
        purposeList.remove();
      }
    }

    // ご採用企業 削除
    let companyList = document.querySelector(".js-companyList");
    if (companyList) {
      // 各クラスの要素を探す
      let companyListJp = companyList.querySelector(".cf_pd_company_list_jp");
      let companyListEn = companyList.querySelector(".cf_pd_company_list_en");
      let companyListCn = companyList.querySelector(".cf_pd_company_list_cn");

      // すべてのクラスが無ければ .js-companyList 要素を削除
      if (!companyListJp && !companyListEn && !companyListCn) {
        companyList.remove();
      }
    }

    // 採用例 削除
    let caseList = document.querySelector(".js-caseList");
    if (caseList) {
      // .cf_pd_purpose_list_jp クラスの要素を探す
      let caseListText = caseList.querySelector(".rt_cf_pd_case_txt");

      // 新たに確認するクラスの要素
      let jpCase = caseList.querySelector(".cf_pd_case_list_jp");
      let enCase = caseList.querySelector(".cf_pd_case_list_en");
      let cnCase = caseList.querySelector(".cf_pd_case_list_cn");

      // いずれの要素も存在しない場合に削除
      if (!caseListText && !jpCase && !enCase && !cnCase) {
        caseList.remove();
      }
    }

    // 用途例,ご採用企業,採用例すべて無い場合、ブロックごと削除
    let exampleWrap = document.querySelector(".js-exampleWrap");
    if (exampleWrap) {
      let purposeText = document.querySelector(".rt_cf_pd_purpose_txt");
      let purposeList = document.querySelector(".js-purposeList");
      let companyList = document.querySelector(".js-companyList");
      let caseList = document.querySelector(".js-caseList");
      if (!purposeText && !purposeList && !companyList && !caseList) {
        exampleWrap.remove();
      }
    }

    // サポート情報　削除
    let supportWrap = document.querySelector(".js-supportInfo");
    if (supportWrap) {
      let supportWrapText = supportWrap.querySelector(".rt_cf_pd_support_txt");
      let supportJpCase = supportWrap.querySelector(".cf_pd_support_list_jp");
      let supportEnCase = supportWrap.querySelector(".cf_pd_support_list_en");
      let supportCnCase = supportWrap.querySelector(".cf_pd_support_list_cn");

      if (
        !supportWrapText &&
        !supportJpCase &&
        !supportEnCase &&
        !supportCnCase
      ) {
        supportWrap.remove();
      }
    }

    // _product_details 特長 削除
    let detailsFeatures = document.querySelector(".js-detailsFeatures");
    if (detailsFeatures) {
      let detailsFeaturesImg =
        detailsFeatures.querySelector(".rt_cf_pd_feat_img");
      let detailsFeaturesText =
        detailsFeatures.querySelector(".rt_cf_pd_feat_txt");
      let detailsFeaturesList = detailsFeatures.querySelector(
        ".cf_pd_feat_list_jp"
      );

      if (!detailsFeaturesImg && !detailsFeaturesText && !detailsFeaturesList) {
        detailsFeatures.remove();
      }
    }

    // _product_details 用途例 削除
    let detailsApplication = document.querySelector(".js-detailsApplication");
    if (detailsApplication) {
      let detailsApplicationImg =
        detailsApplication.querySelector(".rt_cf_pd_purp_img");
      let detailsApplicationText =
        detailsApplication.querySelector(".rt_cf_pd_purp_txt");
      let detailsApplicationList = detailsApplication.querySelector(
        ".cf_pd_purp_list_jp"
      );

      if (
        !detailsApplicationImg &&
        !detailsApplicationText &&
        !detailsApplicationList
      ) {
        detailsApplication.remove();
      }
    }

    // _product_details 製品仕様 削除
    let detailsSpecifications = document.querySelector(
      ".js-detailsSpecifications"
    );
    if (detailsSpecifications) {
      let detailsSpecificationsList01 =
        detailsSpecifications.querySelector(".rt_cf_pd_material");
      let detailsSpecificationsList02 = detailsSpecifications.querySelector(
        ".rt_cf_pd_mesh_count"
      );
      let detailsSpecificationsList03 =
        detailsSpecifications.querySelector(".rt_cf_pd_diameter");
      let detailsSpecificationsList04 =
        detailsSpecifications.querySelector(".rt_cf_pd_case");
      let detailsSpecificationsList05 = detailsSpecifications.querySelector(
        ".rt_cf_pd_mesh_material"
      );
      let detailsSpecificationsList06 =
        detailsSpecifications.querySelector(".rt_cf_pd_method");
      let detailsSpecificationsList07 = detailsSpecifications.querySelector(
        ".rt_cf_pd_subject_material"
      );
      let detailsSpecificationsList08 =
        detailsSpecifications.querySelector(".rt_cf_pd_features");
      let detailsSpecificationsList09 =
        detailsSpecifications.querySelector(".rt_cf_pd_purpose");
      let detailsSpecificationsList10 = detailsSpecifications.querySelector(
        ".rt_cf_pd_resin_material"
      );

      if (
        !detailsSpecificationsList01 &&
        !detailsSpecificationsList02 &&
        !detailsSpecificationsList03 &&
        !detailsSpecificationsList04 &&
        !detailsSpecificationsList05 &&
        !detailsSpecificationsList06 &&
        !detailsSpecificationsList07 &&
        !detailsSpecificationsList08 &&
        !detailsSpecificationsList09 &&
        !detailsSpecificationsList10
      ) {
        detailsSpecifications.remove();
      }
    }

    // _product_details 特性比較 削除
    let detailsCharacteristics = document.querySelector(
      ".js-detailsCharacteristics"
    );
    if (detailsCharacteristics) {
      let detailsCharacteristicsFracture =
        detailsCharacteristics.querySelector(".rt_cf_pd_fracture");
      let detailsCharacteristicsEmulsion =
        detailsCharacteristics.querySelector(".rt_cf_pd_emulsion");
      let detailsCharacteristicsAntistatic =
        detailsCharacteristics.querySelector(".rt_cf_pd_antistatic");

      if (
        !detailsCharacteristicsFracture &&
        !detailsCharacteristicsEmulsion &&
        !detailsCharacteristicsAntistatic
      ) {
        detailsCharacteristics.remove();
      }
    }

    let columnImg2 = document.querySelector(".__column_img2");
    if (columnImg2) {
      let columnImgBlock = columnImg2.querySelector("img");

      if (!columnImgBlock) {
        columnImg2.remove();
      }
    }

    // showroom　テーブル内データが無い場合
    const showroomTbls = document.querySelectorAll(".js-showroomTbl");

    // 各「js-showroomTbl」要素について処理
    showroomTbls.forEach(function (showroomTbl) {
      // 「rt_cf_ex_design」クラスを持つ要素がテーブル内に存在するかチェック
      const designElement = showroomTbl.querySelector(".rt_cf_ex_design");

      // 「rt_cf_ex_design」クラスが存在しない場合
      if (!designElement) {
        // 「js-thRemove」クラスを持つth要素を取得
        const thRemoveElement = showroomTbl.querySelector(".js-thRemove");

        // 該当する要素が存在する場合は削除
        if (thRemoveElement) {
          thRemoveElement.remove();
        }
      }
    });
  };

  const removeProductColumn = () => {
    let selectors = [];

    // クラス名を動的に作成し、配列に追加
    for (let i = 1; i <= 5; i++) {
      selectors.push(`.rt_cf_tech_img_direction_right_${i}`);
      selectors.push(`.rt_cf_tech_img_direction_left_${i}`);
    }

    // 配列内のすべてのセレクタをカンマで連結してクエリセレクタを作成
    let elements = document.querySelectorAll(selectors.join(","));

    elements.forEach(function (element) {
      // 子要素のクラスリストを取得
      let childElements = element.getElementsByTagName("*");
      let hasMatchingClass = false;

      // 子要素に "rt_cf_" から始まるクラスがあるかチェック
      for (var i = 0; i < childElements.length; i++) {
        let classList = childElements[i].classList;
        for (var j = 0; j < classList.length; j++) {
          if (classList[j].startsWith("rt_cf_")) {
            hasMatchingClass = true;
            break;
          }
        }
        if (hasMatchingClass) {
          break;
        }
      }

      // "rt_cf_" から始まるクラスが無ければ、要素を非表示にする
      if (!hasMatchingClass) {
        element.style.display = "none";
      } else {
        element.style.display = ""; // 要素を表示（デフォルトの表示状態に戻す）
      }
    });
  };

  const productRecruitmentLinks = () => {
    // JSON定義
    const getJSONfiles = (recruitment_id) => {
      return `/ajax/category/case/detail/${recruitment_id}.json`;
    };

    let idElements = document.querySelectorAll(".rt_key_list");
    if (!idElements.length) {
      return;
    }

    idElements.forEach((idElement) => {
      let id = idElement.textContent.trim();

      // JSON出力・イベント
      fetch(getJSONfiles(id))
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then(function (data) {
          const productInfo = data.rt_bn_products_info[0];
          let href = "";

          if (
            !productInfo.cf_pd_category_2nd &&
            productInfo.cf_pd_class === 0
          ) {
            href = `/product/${productInfo.cf_pd_division._key}/${productInfo.cf_pd_category_1st.cf_pc1_code}/`;
          } else if (
            !productInfo.cf_pd_category_2nd &&
            productInfo.cf_pd_class !== 0
          ) {
            href = `/product/${productInfo.cf_pd_division._key}/${productInfo.cf_pd_category_1st.cf_pc1_code}/detail/${productInfo._key}.html`;
          } else if (
            productInfo.cf_pd_category_2nd &&
            !productInfo.cf_pd_category_3rd &&
            productInfo.cf_pd_class === 0
          ) {
            href = `/product/${productInfo.cf_pd_division._key}/${productInfo.cf_pd_category_1st.cf_pc1_code}/${productInfo.cf_pd_category_2nd.cf_pc2_code}/`;
          } else if (
            productInfo.cf_pd_category_2nd &&
            !productInfo.cf_pd_category_3rd &&
            productInfo.cf_pd_class !== 0
          ) {
            href = `/product/${productInfo.cf_pd_division._key}/${productInfo.cf_pd_category_1st.cf_pc1_code}/${productInfo.cf_pd_category_2nd.cf_pc2_code}/detail/${productInfo._key}.html`;
          } else if (
            productInfo.cf_pd_category_3rd &&
            productInfo.cf_pd_class === 0
          ) {
            href = `/product/${productInfo.cf_pd_division._key}/${productInfo.cf_pd_category_1st.cf_pc1_code}/${productInfo.cf_pd_category_2nd.cf_pc2_code}/${productInfo.cf_pd_category_3rd.cf_pc3_code}/`;
          } else if (
            productInfo.cf_pd_category_3rd &&
            productInfo.cf_pd_class !== 0
          ) {
            href = `/product/${productInfo.cf_pd_division._key}/${productInfo.cf_pd_category_1st.cf_pc1_code}/${productInfo.cf_pd_category_2nd.cf_pc2_code}/${productInfo.cf_pd_category_3rd.cf_pc3_code}/${productInfo._key}.html`;
          }

          // hrefをすべてのaタグに適用
          let boxElement = idElement.closest(".mod-box1");
          if (boxElement) {
            let linkElements = boxElement.querySelectorAll("a");
            linkElements.forEach((linkElement) => {
              linkElement.href = href;
            });
          }
        })
        .catch(function (error) {
          console.error("There was a problem with the fetch operation:", error);
        });
    });
  };

  const removerelatedDocuments = () => {
    // 関連資料h3削除 日
    const hasCfPdRelatedListJp = document.querySelector('.cf_pd_related_list_jp');
    const hasRtCfPdRelatedDlJp = document.querySelector('.rt_cf_pd_related_dl_jp');
    
    // 両方のクラスが存在しない場合
    if (!hasCfPdRelatedListJp && !hasRtCfPdRelatedDlJp) {
      // js-relatedDocuments要素を取得
      const relatedDocumentsElementJp = document.querySelector('.js-relatedDocuments');
      
      // 要素が存在する場合は削除
      if (relatedDocumentsElementJp) {
        relatedDocumentsElementJp.remove();
      }
    }

    // 関連資料h3削除 英
    const hasCfPdRelatedListEn = document.querySelector('.cf_pd_related_list_en');
    const hasRtCfPdRelatedDlEn = document.querySelector('.rt_cf_pd_related_dl_en');
    
    // 両方のクラスが存在しない場合
    if (!hasCfPdRelatedListEn && !hasRtCfPdRelatedDlEn) {
      // js-relatedDocuments要素を取得
      const relatedDocumentsElementEn = document.querySelector('.js-relatedDocumentsEn');
      
      // 要素が存在する場合は削除
      if (relatedDocumentsElementEn) {
        relatedDocumentsElementEn.remove();
      }
    }

    // 関連資料h3削除 中
    const hasCfPdRelatedListCn = document.querySelector('.cf_pd_related_list_cn');
    const hasRtCfPdRelatedDlCn = document.querySelector('.rt_cf_pd_related_dl_cn');
    
    // 両方のクラスが存在しない場合
    if (!hasCfPdRelatedListCn && !hasRtCfPdRelatedDlCn) {
      // js-relatedDocuments要素を取得
      const relatedDocumentsElementCn = document.querySelector('.js-relatedDocumentsCn');
      
      // 要素が存在する場合は削除
      if (relatedDocumentsElementCn) {
        relatedDocumentsElementCn.remove();
      }
    }
  };

  productAccordion();
  currentUrl();
  selectedOption();
  applicationsAccordion();
  productSideNav();
  searchMeshList();
  columnNewsCreate();
  productBtnLcategory();
  productBtnMcategory();
  productBtnScategory();
  productLineupLinks();
  productSmallCategoryLinks();
  removeProductDetails();
  removeProductColumn();
  productRecruitmentLinks();
  removerelatedDocuments();
})(window.FUNCTIONS);
